<template>
  <div>
    <h3>
      {{item.name}}
      <span v-if="item.detail" class="subheader">{{item.detail}}</span>
    </h3>
    <div v-if="item.description" v-html="$embers.markdown(item.description)"></div>
  </div>
</template>
<script>
export default {
  name: "sheet-rules-display",
  props: ["item"]
};
</script>
